import HrGeneralLeave, { PostHrGeneralLeave } from "app/models/hrGeneralLeave"

export enum Types {
  GET = "HR_GENERAL_LEAVES_GET",
  GET_SUCCESS = "HR_GENERAL_LEAVES_GET_SUCCESS",
  GET_FAIL = "HR_GENERAL_LEAVES_GET_FAIL",
  POST = "HR_GENERAL_LEAVES_POST",
  POST_SUCCESS = "HR_GENERAL_LEAVES_POST_SUCCESS",
  POST_FAIL = "HR_GENERAL_LEAVES_POST_FAIL",
  DELETE = "HR_GENERAL_LEAVES_DELETE",
  DELETE_SUCCESS = "HR_GENERAL_LEAVES_DELETE_SUCCESS",
  DELETE_FAIL = "HR_GENERAL_LEAVES_DELETE_FAIL",
}

export type Action =
  | GetHrGeneralLeavesAction
  | GetHrGeneralLeavesSuccessAction
  | GetHrGeneralLeavesFailAction
  | PostHrGeneralLeaveAction
  | PostHrGeneralLeaveSuccessAction
  | PostHrGeneralLeaveFailAction
  | DeleteHrGeneralLeaveAction
  | DeleteHrGeneralLeaveSuccessAction
  | DeleteHrGeneralLeaveFailAction

export type GetHrGeneralLeavesAction = {
  payload: {
    hrGeneralLeavesRequestParams: {
      from: string
      to: string
    }
  }
  type: Types.GET
}

export type GetHrGeneralLeavesSuccessAction = {
  payload: { hrGeneralLeaves: HrGeneralLeave[] }
  type: Types.GET_SUCCESS
}

export type GetHrGeneralLeavesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostHrGeneralLeaveAction = {
  payload: { hrGeneralLeaves: PostHrGeneralLeave[] }
  type: Types.POST
}

export type PostHrGeneralLeaveSuccessAction = {
  payload: { hrGeneralLeaves: HrGeneralLeave[] }
  type: Types.POST_SUCCESS
}

export type PostHrGeneralLeaveFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type DeleteHrGeneralLeaveAction = {
  payload: { hrGeneralLeaves: HrGeneralLeave[] }
  type: Types.DELETE
}

export type DeleteHrGeneralLeaveSuccessAction = {
  payload: { hrGeneralLeaves: HrGeneralLeave[] }
  type: Types.DELETE_SUCCESS
}

export type DeleteHrGeneralLeaveFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export function getHrGeneralLeaves(hrGeneralLeavesRequestParams: {
  from: string
  to: string
}): GetHrGeneralLeavesAction {
  return {
    payload: { hrGeneralLeavesRequestParams },
    type: Types.GET,
  }
}

export function getHrGeneralLeavesSuccess(hrGeneralLeaves: HrGeneralLeave[]): GetHrGeneralLeavesSuccessAction {
  return {
    payload: { hrGeneralLeaves },
    type: Types.GET_SUCCESS,
  }
}

export function getHrGeneralLeavesFail(errors: object): GetHrGeneralLeavesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function postHrGeneralLeave(payload: { hrGeneralLeaves: PostHrGeneralLeave[] }): PostHrGeneralLeaveAction {
  return {
    payload,
    type: Types.POST,
  }
}

export function postHrGeneralLeaveSuccess(hrGeneralLeaves: HrGeneralLeave[]): PostHrGeneralLeaveSuccessAction {
  return {
    payload: { hrGeneralLeaves },
    type: Types.POST_SUCCESS,
  }
}

export function postHrGeneralLeaveFail(errors: object): PostHrGeneralLeaveFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function deleteHrGeneralLeave(payload: { hrGeneralLeaves: HrGeneralLeave[] }): DeleteHrGeneralLeaveAction {
  return {
    payload,
    type: Types.DELETE,
  }
}

export function deleteHrGeneralLeaveSuccess(hrGeneralLeaves: HrGeneralLeave[]): DeleteHrGeneralLeaveSuccessAction {
  return {
    payload: { hrGeneralLeaves },
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteHrGeneralLeaveFail(errors: object): DeleteHrGeneralLeaveFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}
